import { Component, inject } from '@angular/core';
import { RedesSociaisPublicasService } from '../../services/redes-sociais-publicas.service';

@Component({
  selector: 'app-redes-sociais',
  templateUrl: './redes-sociais.component.html',
  styleUrls: ['./redes-sociais.component.css'],
})
export class RedesSociaisComponent {
  /** As redes do órgão, no banner da homepage e no rodapé. Vazio sem cadastro ou com a API fora. */
  readonly redesSociais = inject(RedesSociaisPublicasService).redes;
}
